var map = {
	".": "nAo7",
	"./": "nAo7",
	"./2023-09-12": "WisP",
	"./2023-09-12.json": "WisP",
	"./index": "nAo7",
	"./index.js": "nAo7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2/8n";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/q&a ^.*$
// module id = 2/8n
// module chunks = 3